// extracted by css-extract-rspack-plugin
export default {"rejectedEligibilityTagsWrapper":"VerificationSummaryCard_rejectedEligibilityTagsWrapper__JH4fE","statusCheckWrapper":"VerificationSummaryCard_statusCheckWrapper__5vZtr"};